import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-sand py-11 sm:py-14" data-id="element-32" data-mp="187097aujeyf7">
      <div className="mx-auto max-w-md px-5 sm:max-w-4xl" data-id="element-33" data-mp="13cml7ti7ftkk">
        <div className="text-center" data-id="element-34" data-mp="yf2v9wc59scs">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-3.5 py-1.5 font-display text-[0.62rem] font-bold uppercase tracking-editorial text-white" data-id="element-35" data-mp="ye1jfpnb11u0">
            <GiftIcon className="h-3 w-3" aria-hidden strokeWidth={2.5} data-id="element-36" data-mp="og58axuda6vw" />
            Incluidos gratis con tu compra
          </span>
          <h2 className="mx-auto mt-3.5 max-w-[22ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[26ch] sm:text-[2rem]" data-id="element-37" data-mp="kflea353bjdz">
            5 recursos extra para emprender{' '}
            <span className="text-gold-deep" data-id="element-38" data-mp="2er040jy3pitq">incluidos gratis</span>
          </h2>
          <p className="mx-auto mt-2.5 max-w-[46ch] font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-39" data-mp="29uj996wec67o">
            Además de las 200 fórmulas, recibís herramientas prácticas para ayudarte a producir,
            organizar tus costos, mostrar tus jabones y empezar a vender.
          </p>
        </div>

        {/* Portadas protagonistas: en mobile tarjeta horizontal (portada +
            texto) para no alargar la página; en tablet tarjetas verticales de
            a 2, y en desktop filas centradas de 3 + 2. */}
        <ul className="mt-7 flex flex-col gap-3.5 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-4 lg:gap-5" data-id="element-40" data-mp="1alhzbx21esj9">
          {BONOS.map((bono, i) => <motion.li key={bono.num} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.24,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 4) * 0.04
        }} className="flex items-start gap-4 rounded-2xl bg-white p-3 sm:w-[calc((100%-1rem)/2)] sm:flex-col sm:gap-0 sm:p-3.5 lg:w-[calc((100%-2.5rem)/3)]" data-id="element-41" data-mp="10sj1rpokbrni" data-mpi={i}>
              <img src={bono.cover} alt={`Portada del Bono ${bono.num}: ${bono.name}`} loading="lazy" decoding="async" width={1254} height={1254} sizes="(max-width: 640px) 144px, (max-width: 1024px) 300px, 280px" className="aspect-square w-[8.5rem] shrink-0 rounded-xl object-cover sm:w-full" data-id="element-42" data-mp="235c3bugctwis" />
              <div className="flex min-w-0 flex-col pt-0.5 sm:px-1 sm:pt-4" data-id="element-43" data-mp="1kdt0poq8skha">
                <div className="flex flex-wrap items-center gap-1.5" data-id="element-44" data-mp="1fhcc6tf4s43o">
                  <span className="rounded-md bg-gold-soft px-2 py-0.5 font-display text-[0.6rem] font-bold uppercase tracking-[0.08em] text-gold-deep" data-id="element-45" data-mp="1ahg6mpqsc4m0">
                    Bono {bono.num}
                  </span>
                  <span className="rounded-full border border-champagne/60 bg-coral-soft px-2 py-0.5 font-display text-[0.56rem] font-bold uppercase tracking-[0.1em] text-[#8A6A2B]" data-id="element-46" data-mp="11fzzcqv9oim0">
                    Incluido gratis
                  </span>
                </div>
                <h3 className="mt-2 font-display text-[0.84rem] font-bold leading-snug text-charcoal sm:text-[0.92rem]" data-id="element-47" data-mp="3h7b7w35xazdm">
                  {bono.name}
                </h3>
                <p className="mt-1.5 font-sans text-[0.76rem] leading-relaxed text-taupe sm:text-[0.8rem]" data-id="element-48" data-mp="3r34hbdocicr6">
                  {bono.role}
                </p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}